class WhoWeArePageController {
  constructor(modalID) {
    this.modalCtrl = new ModalController({ modalID });
  }

  initialize(content) {
    this.content = content;
    this.modalCtrl.initialize();

    $('[modal-data]').click((event) => {
      event.preventDefault();
      this.showInfo($(event.target).attr('modal-data'));
    });
  }

  showInfo(partner) {
    const { title, text } = this.content[partner];
    const html = `
<div class='WhoWeAre__modal-content'>
  <h4 class='Modal__title'>${title}</h4>
  ${text}
</div>
    `;

    this.modalCtrl.setHtmlContent({ html });
    this.modalCtrl.openModal();
    this.modalCtrl.show();
  }
}
